import { PublicRoutes } from "@/constants/routes";
import { Link } from "react-router";
import { TOOLS } from "./constants";
import { ToolCard } from "./components/toolCard";
import { ToolPageLayout } from "./components/toolPageLayout";
import { ToolResultCta } from "./components/toolResultCta";
import {
  COLLECTION,
  DESCRIPTION,
  FAQ_ITEMS,
  TITLE,
  TRAIL,
} from "./hubConstants";

export const Ferramentas = () => (
  <ToolPageLayout
    title={TITLE}
    description={DESCRIPTION}
    trail={TRAIL}
    schemas={[COLLECTION]}
    eyebrow="Ferramentas grátis"
    heading="Ferramentas grátis para o crediário da sua loja"
    lead={
      <>
        Carnê, simulação de parcelas e a conta de quanto a inadimplência custa,
        sem cadastro. Para ir além das contas, o{" "}
        <Link
          to={PublicRoutes.BLOG}
          className="text-ds-brand-700 hover:text-ds-brand-800 focus-visible:outline-ds-focus cursor-pointer underline underline-offset-4 focus-visible:outline-2"
        >
          blog da Fidexa
        </Link>{" "}
        explica como cobrar melhor o crediário próprio.
      </>
    }
    faqItems={FAQ_ITEMS}
    faqHeading="Dúvidas sobre as ferramentas"
  >
    {openDemo => (
      <>
        <section
          aria-label="Ferramentas disponíveis"
          className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8"
        >
          <ul className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {TOOLS.map(tool => (
              <li key={tool.key}>
                <ToolCard tool={tool} />
              </li>
            ))}
          </ul>
        </section>
        <div className="mx-auto w-full max-w-6xl px-4 sm:px-6 lg:px-8">
          <ToolResultCta
            id="hub-cta-title"
            title="Das contas para a cobrança no automático"
            description="A Fidexa lembra o cliente antes do vencimento, cobra o atraso e fecha acordo pelo WhatsApp, com Pix na mesma conversa."
            onDemo={openDemo}
          />
        </div>
      </>
    )}
  </ToolPageLayout>
);
